export default __webpack_public_path__ + "static/media/twitter.b6f8ce7b.png";